import React from 'react'
import sizeType from '../util/sizeStyle'

const Input = ({ item, value, validationMessage, handleChange, defaultValue, formData }) => {
  const disabled = typeof item.disabled === 'function' ? item.disabled(formData) : item.disabled || false
  const inputValue = value || defaultValue || ''
  // Return Input in view
  return (
    <>
      <input
        name={item.name}
        type={item.type}
        placeholder={item.placeholder}
        disabled={disabled}
        className={`transition-all outline-none
                    ${item.disabled && 'disabled'}
                    w-full text-text-md text-gray-900 rounded-md border border-gray-300 bg-white
                    placeholder:text-gray-400 placeholder:text-text-md
                    focus:shadow-focus focus:border-primary-500
                    hover:border-primary-500 shadow-xs
                    ${sizeType[item.size]}
                    ${item.innerClassName || ''}
                    ${validationMessage ? 'border-red-500 border-2' : ''}
                `}
        autoComplete="off"
        value={inputValue}
        onChange={(e) => {
          if (handleChange) handleChange(e.target.value, item.name)
        }}
        onFocus={(e) => {
          if (item.handleFocus) item.handleFocus(e.target.value, item.name)
        }}
        onBlur={(e) => {
          if (item.handleBlur) item.handleBlur(e.target.value, item.name)
        }}
        onKeyPress={(e) => {
          if (item.handleKeyPress) item.handleKeyPress(e)
        }}
        autoFocus={item?.autoFocus}
      />
      {defaultValue}
    </>
  )
}

export default Input
